<template>
  <div>
    <md-dialog :md-active.sync="isPictureModalShowing">
      <md-dialog-content>
        <h3>Pictures</h3>
        <view-image :key="p" :src="p" v-for="p in photos"/>
      </md-dialog-content>
      <md-dialog-actions>
        <download-pictures-button :pics="photos"/>
        <md-button class="md-primary" @click="isPictureModalShowing = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-card class="searchPanel">
        <md-card-expand>
        <md-card-expand-content>
      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-40 md-small-size-100">
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <datepicker v-model="searchRequest.etaAssignedStart">
                  <label>ETA Assigned</label>
                </datepicker>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <datepicker v-model="searchRequest.etaAssignedEnd">
                  <label>To</label>
                </datepicker>
              </div>
            </div>

            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <datepicker v-model="searchRequest.pickUpStart">
                  <label>Pickup Date</label>
                </datepicker>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <datepicker v-model="searchRequest.pickUpEnd">
                  <label>To</label>
                </datepicker>
              </div>
            </div>

          </div>
          <div class="md-layout-item md-size-60 md-small-size-100">
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-30 md-small-size-100">
                <auto-complete-master-data-multiple-select
                    group="Hauler"
                    label="Hauler"
                    v-model="searchRequest.haulers">
                </auto-complete-master-data-multiple-select>
              </div>

              
              <div class="md-layout-item md-size-30 md-small-size-100">
                <auto-complete-master-data-multiple-select
                    group="ProblemCode"
                    label="Problem"
                    v-model="searchRequest.problems">
                </auto-complete-master-data-multiple-select>
              </div>

              <div class="md-layout-item md-size-30 md-small-size-100">
                <auto-complete-search-store-multiple-select
                    multiple="true"
                    label="Store"
                    :join-end-outlets="true"
                    v-model="searchRequest.storeIds">
                </auto-complete-search-store-multiple-select>

            </div>

            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <auto-complete-master-data-multiple-select
                    :prepared-options="getDriverGroupOptionsForUser"
                    v-model="searchRequest.driverGroups"
                    label="Driver Group">
                </auto-complete-master-data-multiple-select>
              </div>

               <div class="md-layout-item md-size-50 md-small-size-100">
                <auto-complete-master-data-multiple-select
                        :preparedOptions="drivers"
                        label="Driver"
                        v-model="searchRequest.drivers"
                        display-type="idOnly"
                        >
                </auto-complete-master-data-multiple-select>
              </div>


              

              </div>
            </div>

          </div>
        </div>
      </md-card-content>
      </md-card-expand-content>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-50 md-small-size-100">
            <calling-api path="/api/w/billOfLoads/save" v-if="getPermission.loads.edit">
              <md-button class="md-raised md-primary" :disabled="!hasExtraCost" @click="doCheckExtraCost">Extra Cost</md-button>
              <md-button class="md-raised md-primary" :disabled="!canEdit" @click="doEdit">Change</md-button>
              <md-button class="md-raised md-primary" :disabled="!canSave" @click="doSave">Save</md-button>
            </calling-api>
          </div>

          <div class="md-layout-item md-size-50 md-small-size-100">
            <md-card-actions>
              <calling-api path="/api/w/billOfLoads">
                <md-checkbox v-model="filterUpdatedToSapFail" v-if="getRole.isAcnIT">
                  Show only update to SAP failed
                </md-checkbox>
                <md-button @click="doSearch" class="md-primary md-raised">Search</md-button>
                <md-button @click="clearSearch" class="md-raised">Clear</md-button>
              </calling-api>
               <md-card-expand-trigger>
            <md-button class="md-icon-button" id="expand-button">
              <md-icon>keyboard_arrow_down</md-icon>
            </md-button>
          </md-card-expand-trigger>
            </md-card-actions>
          </div>
        </div>
      </md-card-content>
      </md-card-expand>
    </md-card>
    <br/>

    <pagination :items="getItemsToDisplay">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container">
            <div class="inner-container">

              <div class="table-header">
                <table id="headertable">
                  <thead>
                  <tr>
                    <th class="header-cell w3" v-if="getPermission.loads.edit">
                      <md-checkbox v-model="allItemsSelected" @change="handleAllItemSelectedChanged"/>
                    </th>
                    <th class="header-cell w3">Extra Cost</th>
                    <th class="header-cell w5">Pick Up date</th>
                    <th class="header-cell w3">Store</th>
                    <th class="header-cell w7">Load Id</th>
                    <th class="header-cell w7">BOL</th>
                    <th class="header-cell w4">BOL Status</th>
                    <th class="header-cell w12">Problem</th>
                    <th class="header-cell w5">Remark</th>
                    <th class="header-cell w5">Bales Picked</th>
                    <th class="header-cell w5">Bales Left</th>
                    <th class="header-cell w5">Photo Linkage</th>
                    <th class="header-cell w5">Driver</th>
                    <th class="header-cell w5">Hauler</th>
                    <th class="header-cell w5">Driver Group</th>
                    <th class="header-cell w5">EC Person</th>
                    <th class="header-cell w5">EC Date</th>
                    <th class="header-cell w3">EC Time</th>
                    <th class="header-cell w5">Change Person</th>
                    <th class="header-cell w5">Change Date</th>
                    <th class="header-cell w5">Change Time</th>
                    <th v-if="getRole.isAcnIT" class="header-cell w6">Updated to SAP</th>
                    <th v-if="getRole.isAcnIT" class="header-cell w6">Updated to SAP Date</th>
                    <th v-if="getRole.isAcnIT" class="header-cell w15">Updated to SAP message</th>
                  </tr>
                  </thead>
                </table>
              </div>
              <div class="table-body" @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                  <tr class="" v-for="item in pageItems">
                    <td class="body-cell w3" v-if="getPermission.loads.edit">
                      <md-checkbox v-model="item.selected"/>
                    </td>
                    <td class="body-cell w3">
                      <md-checkbox disabled v-model="item.extraCost"/>
                    </td>
                    <td class="body-cell w5">{{item.pickUpDate}}</td>
                    <td class="body-cell w3">{{item.storeId}}</td>
                    <td class="body-cell w7">{{item.loadIdUsed}}</td>
                    <td class="body-cell w7">{{item.id}}</td>
                    <td class="body-cell w4">
                      <template v-if="item.edit">
                        <template v-if="item.bolConfirmStatus === 'C' || item.bolConfirmStatus === 'D'">
                          <md-field>
                            <md-select v-model="item.bolConfirmStatus">
                              <md-option value="C">C</md-option>
                              <md-option value="D">D</md-option>
                            </md-select>
                          </md-field>
                        </template>
                      </template>
                      <template v-else>{{item.bolConfirmStatus}}</template>
                    </td>
                    <td class="body-cell w12">
                      <template v-if="item.edit">
                        <auto-complete-master-data-select
                            group="ProblemCode"
                            :init-value-id="item.problemCode"
                            :on-item-changed="handleProblemCodeChange(item)"
                        >
                        </auto-complete-master-data-select>
                      </template>
                      <template v-else>{{item.problem}}</template>
                    </td>
                    <td class="body-cell w5">
                      <template v-if="item.edit">
                        <md-field>
                          <md-input v-model="item.remark"/>
                        </md-field>
                      </template>
                      <template v-else>{{item.remark}}</template>
                    </td>
                    <td class="body-cell w5">{{item.balePicked}}</td>
                    <td class="body-cell w5">{{item.baleLeft}}</td>
                    <td class="body-cell w5">
                      <template v-if="item.PhotoLinkage.length > 0">
                        <a href="" @click.prevent="toggleItemPhoto(item.PhotoLinkage)">{{item.PhotoLinkage.length}} photos</a>
                      </template>
                      <template v-else>
                        <span>0 photos</span>
                      </template>
                    </td>
                    <td class="body-cell w5">{{item.driverId}}</td>
                    <td class="body-cell w5">{{item.haulerId}}</td>
                    <td class="body-cell w5">{{item.driverGroup}}</td>
                    <td class="body-cell w5">{{item.extraCostBy}}</td>
                    <td class="body-cell w5">{{item.extraCostDate}}</td>
                    <td class="body-cell w3">{{item.extraCostTime}}</td>
                    <td class="body-cell w5">{{item.updatedBy}}</td>
                    <td class="body-cell w5">{{item.updatedDate}}</td>
                    <td class="body-cell w5">{{item.updatedTime}}</td>
                    <td v-if="getRole.isAcnIT" class="body-cell w6">{{item.extraCostUpdatedToSap}}</td>
                    <td v-if="getRole.isAcnIT" class="body-cell w6">{{item.extraCostUpdatedToSapAt | date}} {{item.updatedToSapAt | time}}</td>
                    <td v-if="getRole.isAcnIT" class="body-cell w15">{{item.extraCostUpdatedToSapMessage}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>
  </div>
</template>

<style scoped>
</style>

<script>
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  import _ from 'underscore';

  function getInitSearchRequest() {
    return {
      etaAssignedStart: null,
      etaAssignedEnd: null,
      pickUpStart: null,
      pickUpEnd: null,
      haulers: [],
      problems: [],
      driverGroups: [],
      storeIds: [],
      problemOnly: true,
      drivers:[],
    };
  }

  export default {
    data: () => ({
      searchRequest: getInitSearchRequest(),
      items: [],
      isPictureModalShowing: false,
      photos: [],
      drivers: null,
      allItemsSelected: false,
      filterUpdatedToSapFail: false,
    }),
    computed: {
      ...mapGetters([
        'getBillOfLoadProblems',
        'getPermission',
        'getMasterDataName',
        'getRole',
        'getDriverGroupOptionsForUser',
      ]),
      getSelectedItems() {
        return _(this.getItemsToDisplay).filter(it => it.selected);
      },
      getItemsToDisplay() {
        if (this.filterUpdatedToSapFail) {
          return _(this.items).filter(it => it.extraCostUpdatedToSap === false);
        }
        return this.items;
      },
      canEdit() {
        return this.getSelectedItems.length > 0;
      },
      hasExtraCost() {
        const selectedItems = this.getSelectedItems;
        return _(selectedItems).filter(it => it.extraCost !== true).length > 0;
      },
      canSave() {
        return this.getSelectedItems.length > 0;
      },
    },
    watch: {
      getBillOfLoadProblems(val) {
        this.updateCachedBillOfLoadProblemsFromApi(val);
      },
    },
    mounted() {
      this.$el.querySelector('#expand-button')
        .click();
      const cachedSearchRequest = this.$store.state.billOfLoadWithProblem.searchRequest;
      if (cachedSearchRequest && !_(cachedSearchRequest).isEmpty()) {
        this.searchRequest = JSON.parse(JSON.stringify(cachedSearchRequest));
      }

     this.$store.dispatch('getUsersByCategory', { category: 'A' })
        .then((res) => {
          this.drivers = res;
        });
      this.updateCachedBillOfLoadProblemsFromApi(this.getBillOfLoadProblems);
    },
    methods: {
      handleScroll(e) {
        $(this.$el.querySelector('.table-header')).offset({ left: -1 * (e.target.scrollLeft - $('.outer-container').offset().left) })
      },
      doSearch() {
        this.$store.dispatch('loadBillOfLoadProblems', this.searchRequest)
      },
      clearSearch() {
        _(this.$el.querySelectorAll('.searchPanel .md-field button.md-input-action.md-clear')).each(it => {
          it.click();
        });
        this.$nextTick(() => {
          this.searchRequest = getInitSearchRequest();
        });
      },
      doCheckExtraCost() {
        _(this.getSelectedItems).each(item => {
          item.extraCost = true;
        });
      },
      doEdit() {
        const items = _(this.items).map(it => {
          _(this.getSelectedItems).each(item => {
            if (it.id + it.loadIdUsed === item.id + item.loadIdUsed) {
              it.edit = true;
            }
          });
          return it;
        })
        this.items = items;
      },
      updateBillOfLoadProblems(newItem) {
        this.items = newItem;
      },
      updateCachedBillOfLoadProblemsFromApi(item) {
        const newItem = JSON.parse(JSON.stringify(item));
        this.updateBillOfLoadProblems(
          _(newItem).map(it => {
            const photos = _.without([it.balesLeftPic, it.problemPic1, it.problemPic2, it.problemPic3], null);
            return {
              extraCost: it.extraCost === true,
              pickUpDate: dateFormat.date(it.pickUpDate),
              pickUpTime: dateFormat.timeHHmm(it.pickUpDate),
              storeId: it.storeId,
              loadIdUsed: it.loadIdUsed,
              id: it.id,
              bolConfirmStatus: it.bolConfirmStatus,
              problem: it.problem,
              problemCode: it.problemCode,
              remark: it.remark,
              balePicked: it.balePicked,
              baleLeft: it.baleLeft,
              PhotoLinkage: photos,
              driverId: it.driverId,
              haulerId: it.haulerId,
              driverGroup: it.driverGroup,
              extraCostBy: it.extraCostBy,
              extraCostDate: dateFormat.date(it.extraCostAt),
              extraCostTime: dateFormat.timeHHmm(it.extraCostAt),
              updatedBy: it.updatedBy,
              updatedDate: dateFormat.date(it.updatedAt),
              updatedTime: dateFormat.timeHHmm(it.updatedAt),
              eta: it.eta,
              bolWeight: it.bolWeight,
              loadWeight: it.loadWeight,
              weightUnit: it.weightUnit,
              scaleTicket: it.scaleTicket,
              scheduleId: it.scheduleId,
              selected: false,
              selectedExtraCost: false,
              edit: false,
              extraCostUpdatedToSap: it.extraCostUpdatedToSap,
              extraCostUpdatedToSapAt: it.extraCostUpdatedToSapAt,
              extraCostUpdatedToSapMessage: it.extraCostUpdatedToSapMessage,
            }
          })
        );
      },
      toggleItemPhoto(photos) {
        this.photos = photos;
        this.isPictureModalShowing = true;
      },
      handleAllItemSelectedChanged() {
        _(this.items).each(it => {
          it.selected = this.allItemsSelected;
        })
      },
      handleProblemCodeChange(item) {
        return (id, name) => {
          item.problemCode = id;
          item.problem = name;
        }
      },
      doSave() {
        const combineDateAndTime = (date, time) => {
          if (!date) {
            return null;
          }
          const dateString = moment(date).format('YYYYMMDD');
          const timeString = time ? time : '00:00';
          return moment(dateString + timeString, 'YYYYMMDDHHmm').toDate()
        };

        const requests = _(this.getSelectedItems).map(it => {
          return {
            problemCode: it.problemCode,
            bolConfirmStatus: it.bolConfirmStatus,
            remark: it.remark,
            storeId: it.storeId,
            loadIdUsed: it.loadIdUsed,
            eta: it.eta,
            pickUpDate: combineDateAndTime(it.pickUpDate, it.pickUpTime),
            driverId: it.driverId,
            haulerId: it.haulerId,
            id: it.id,
            balePicked: it.balePicked,
            baleLeft: it.baleLeft,
            bolWeight: it.bolWeight,
            loadWeight: it.loadWeight,
            weightUnit: it.weightUnit,
            problem: it.problem,
            scaleTicket: it.scaleTicket,
            scheduleId: it.scheduleId,
            extraCost: it.extraCost,
          };
        });
        this.$store.dispatch('saveBillOfLoadProblems', { billOfLoads: requests }).then(() => {
          this.$store.dispatch('loadBillOfLoadProblems');
        })
      },
    }
  }

</script>
